import { render } from "./PendingDeliveries.vue?vue&type=template&id=c50943d8"
import script from "./PendingDeliveries.vue?vue&type=script&lang=js"
export * from "./PendingDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__